import React from "react";
import { FormattedMessage } from "react-intl";

import { isNone } from "~/common/assert";
import { versionize } from "~/common/courses";
import { LabelledValue } from "~/components/ui/labelled-value";
import type { TPatientList } from "~/reducers/dashboard";
import type { TPatient } from "~/types/patient";

export function PatientCardCourse({ patient }: { patient: TPatient }) {
  return (
    <LabelledValue label={<FormattedMessage id="HEADER_INSTRUCTIONS" />}>
      <CourseName patient={patient} />
    </LabelledValue>
  );
}

/**
 * Typed to what it actually READS (the course tag + the version), not to `TPatientList` specifically, so
 * the richer `TPatient` — which carries the same two fields on a fatter `course` object — is accepted
 * without a cast. The patient-view card renders this with a `TPatient`.
 */
export function CourseName({
  patient,
}: {
  patient: Pick<TPatientList, "course_version"> & { course: Pick<TPatientList["course"], "course"> };
}) {
  if (isNone(patient.course.course)) {
    return <FormattedMessage id="None" />;
  }

  return (
    <FormattedMessage
      id={versionize(patient.course.course, patient.course_version)}
      defaultMessage=" "
    />
  );
}
